export const getTabClassName = (notSaved?: boolean) =>
  notSaved ? 'not-saved-tab' : '';

export const buildTabTitle = (
  unwrittenText: string,
  title: string,
  notSaved?: boolean,
) => {
  return `${title} ${notSaved ? `(${unwrittenText})` : ''}`;
};

import { useNavigate } from 'react-router-dom';

export function useChangeTab<T>() {
  const navigate = useNavigate();

  return (key: T) =>
    navigate(`${location.pathname}${location.search || ''}`, {
      state: {
        tabKey: key,
      },
    });
}
